// Pixie's own typefaces: Nunito (titles) + DM Sans (body). Loaded on demand —
// only once the Pixie tab is actually revealed — so a player load that never
// shows the assistant never pays for the font request. Idempotent: the dedupe
// id means repeat calls (reveal + first open) inject one stylesheet, not two.
const STYLESHEET_ID = "pixie-fonts";
const FONT_CSS_URL =
  "https://fonts.googleapis.com/css2?family=Nunito:wght@700&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,700&display=swap";

export function loadPixieFonts(): void {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById(STYLESHEET_ID)) {
    return;
  }
  const preconnect = document.createElement("link");
  preconnect.rel = "preconnect";
  preconnect.href = "https://fonts.gstatic.com";
  preconnect.crossOrigin = "anonymous";
  document.head.appendChild(preconnect);

  const stylesheet = document.createElement("link");
  stylesheet.id = STYLESHEET_ID;
  stylesheet.rel = "stylesheet";
  stylesheet.href = FONT_CSS_URL;
  document.head.appendChild(stylesheet);
}
